/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import { React, Component } from 'react';
import { Icon } from '../../../ui/Icon';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as Styles from './index.styles';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import Picture from '../../../ui/Picture';
const mainImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
  },
};
export default class Card extends SafePureComponent {
  safeRender() {
    const { data } = this.props;
    const CarouselCompanyLogo = get(data.fields, 'Logo', '');
    const CarouselImage = get(data.fields, 'Image', '');
    const CarouselImageCaption = get(data.fields, 'IntroText.value', '');
    const CarouselLink = get(data.fields, 'Link', '');

    return (
      <div className="swiper-slide" css={[Styles.whatwedocardui]}>
        <a href={CarouselLink.value.href}>
          <div>
            <div className="main_img">
              {CarouselImage && (
                <Picture
                  image={CarouselImage}
                  imageSizes={mainImageSizes}
                  instantLoad
                />
              )}
            </div>
            {CarouselCompanyLogo && (
              <div className="logo_img">
                <Picture
                  image={CarouselCompanyLogo}
                  imageSizes={mainImageSizes}
                  instantLoad
                />
                <div className="textp">
                  <p>{CarouselImageCaption}</p>
                </div>
              </div>
            )}
          </div>
          <div></div>
        </a>
      </div>
    );
  }
}
